/* ============================================================================
   EH SALE UPSELL — tennis product-page 重ね付け / combo pitch
   ----------------------------------------------------------------------------
   On SALE-tennis product pages (handle contains "タイムセール-tennis"), injects a
   premium block that turns "1本" into a combo using 2BUY1FREE (add 3 → cheapest
   1 free): stacking, color-mixing, necklace×bracelet combos. Placed right under
   the カートに入れる button (.product-single__add-to-cart). Additive / self-contained /
   non-destructive. Brand base #385C60 + gold. Links to the sale collection.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__ehSaleUpsell) return;
  window.__ehSaleUpsell = true;

  if (!document.body || !/(^|\s)template-product(\s|$)/.test(document.body.className)) return;

  var path = '';
  try { path = decodeURIComponent(location.pathname); } catch (e) { path = location.pathname; }
  if (path.indexOf('タイムセール-tennis') === -1) return; // sale tennis pages only

  var COLLECTION_URL = '/collections/' + encodeURIComponent('タイムセール');

  var CSS = [
    '#eh-sale-upsell{--e1:#385C60;--gd:#e9c987;--gd2:#c8a45c;margin:20px 0;font-family:inherit;}',
    '.ehsu-card{position:relative;overflow:hidden;border-radius:18px;padding:clamp(20px,4vw,30px) clamp(18px,4vw,30px);color:#fff;isolation:isolate;',
    'background:radial-gradient(90% 120% at 92% 4%,rgba(233,201,135,.26),transparent 58%),linear-gradient(135deg,#22403f 0%,#385C60 52%,#4a848a 100%);box-shadow:0 18px 40px -22px rgba(22,41,43,.7),inset 0 0 0 1px rgba(233,201,135,.16);}',
    '.ehsu-eyebrow{font-size:11px;letter-spacing:.22em;font-weight:800;text-transform:uppercase;color:var(--gd);margin:0 0 8px;}',
    '.ehsu-title{margin:0;font-size:clamp(20px,3.4vw,28px);font-weight:900;letter-spacing:.02em;line-height:1.28;color:#fff;}',
    '.ehsu-title b{background:linear-gradient(180deg,#fff,#fdf3d6 42%,#e9c987 80%,#d9b264);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:transparent;}',
    '.ehsu-sub{margin:10px 0 0;font-size:clamp(12.5px,1.7vw,14px);line-height:1.8;color:rgba(232,242,242,.9);font-weight:500;}',
    '.ehsu-sub b{color:#fff;font-weight:800;}',
    '.ehsu-combos{margin:clamp(16px,3vw,22px) 0 0;display:flex;flex-direction:column;gap:9px;}',
    '.ehsu-combo{display:flex;align-items:center;gap:10px;padding:12px 14px;border-radius:13px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);}',
    '.ehsu-combo--best{background:linear-gradient(180deg,rgba(233,201,135,.18),rgba(200,164,92,.07));border-color:rgba(233,201,135,.42);}',
    '.ehsu-mix{flex:1 1 auto;min-width:0;font-size:clamp(12.5px,1.7vw,14.5px);font-weight:700;line-height:1.45;color:#fff;}',
    '.ehsu-mix b{color:var(--gd);font-weight:900;margin:0 .1em;}',
    '.ehsu-arrow{flex:0 0 auto;color:rgba(233,201,135,.65);font-size:15px;}',
    '.ehsu-pay{flex:0 0 auto;text-align:right;line-height:1.15;}',
    '.ehsu-price{display:block;font-size:clamp(17px,2.6vw,22px);font-weight:900;color:#fff;letter-spacing:.01em;}',
    '.ehsu-note{display:block;margin-top:2px;font-size:10.5px;font-weight:700;color:var(--gd);white-space:nowrap;}',
    '.ehsu-punch{margin:clamp(16px,3vw,20px) 0 0;font-size:clamp(13px,1.9vw,15px);font-weight:800;letter-spacing:.01em;color:#fff;text-align:center;}',
    '.ehsu-punch b{color:var(--gd);}',
    '.ehsu-cta{display:flex;align-items:center;justify-content:center;gap:.5em;margin:14px auto 0;max-width:340px;font-size:14px;font-weight:800;letter-spacing:.03em;text-decoration:none;color:#22383a;background:linear-gradient(180deg,#fff7e3,#f4d896 46%,#e2b866);padding:.85em 1.5em;border-radius:999px;box-shadow:0 10px 22px -9px rgba(226,184,102,.75);transition:transform .2s ease,box-shadow .2s ease;}',
    '.ehsu-cta span{transition:transform .2s ease;}',
    '.ehsu-cta:hover{transform:translateY(-2px);box-shadow:0 16px 28px -9px rgba(226,184,102,.85);}',
    '.ehsu-cta:hover span{transform:translateX(4px);}',
    '@media(max-width:480px){.ehsu-combo{gap:7px;padding:11px 12px;}.ehsu-arrow{display:none;}}'
  ].join('\n');

  function build() {
    var sec = document.createElement('section');
    sec.id = 'eh-sale-upsell';
    sec.setAttribute('aria-label', '2BUY1FREE 組み合わせ提案');
    sec.innerHTML =
      '<div class="ehsu-card">' +
        '<p class="ehsu-eyebrow">MORE IS MORE ・ 2BUY1FREE</p>' +
        '<h2 class="ehsu-title">1本で、終わらせないで。<br><b>2本分の値段で、3本。</b></h2>' +
        '<p class="ehsu-sub">このセールは<b>「カートに3点で、1番安い1点が¥0」</b>。同じ色を重ねても、色違いでも、ネックレス×ブレスレットの合わせ技でもOK。“ありえない”組み合わせが作れます。</p>' +
        '<div class="ehsu-combos">' +
          '<div class="ehsu-combo ehsu-combo--best">' +
            '<span class="ehsu-mix">テニスチェーン <b>×3本</b>（重ね付け／色違い）</span>' +
            '<span class="ehsu-arrow" aria-hidden="true">&#8594;</span>' +
            '<span class="ehsu-pay"><span class="ehsu-price">¥20,000</span><span class="ehsu-note">1本無料・実質¥6,667/本</span></span>' +
          '</div>' +
          '<div class="ehsu-combo">' +
            '<span class="ehsu-mix">ネックレス <b>×2</b> ＋ ブレスレット <b>×1</b></span>' +
            '<span class="ehsu-arrow" aria-hidden="true">&#8594;</span>' +
            '<span class="ehsu-pay"><span class="ehsu-price">¥20,000</span><span class="ehsu-note">ブレスレットが¥0</span></span>' +
          '</div>' +
          '<div class="ehsu-combo">' +
            '<span class="ehsu-mix">ネックレス <b>×1</b> ＋ ブレスレット <b>×2</b></span>' +
            '<span class="ehsu-arrow" aria-hidden="true">&#8594;</span>' +
            '<span class="ehsu-pay"><span class="ehsu-price">¥15,000</span><span class="ehsu-note">ブレスレット1本が¥0</span></span>' +
          '</div>' +
        '</div>' +
        '<p class="ehsu-punch">ゴールド × ホワイトゴールドの<b>重ね付け</b>が人気。<br>今だけの、ありえない組み合わせを。</p>' +
        '<a class="ehsu-cta" href="' + COLLECTION_URL + '">組み合わせを選ぶ <span>&#8594;</span></a>' +
      '</div>';
    return sec;
  }

  function place(node) {
    if (document.getElementById('eh-sale-upsell')) return true;
    // Real product-page DOM (verified): right under the カートに入れる button.
    var atc = document.querySelector('.product-single__add-to-cart');
    if (atc && atc.parentNode) { atc.insertAdjacentElement('afterend', node); return true; }
    var form = document.querySelector('form.js-addtocart-form, .product-single__form');
    if (form && form.parentNode) { form.insertAdjacentElement('afterend', node); return true; }
    var info = document.querySelector('.product-single__metas, .bwp-single-info');
    if (info) { info.appendChild(node); return true; }
    return false;
  }

  function run() {
    if (document.getElementById('eh-sale-upsell')) return;
    var style = document.createElement('style');
    style.id = 'eh-sale-upsell-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
    var node = build();
    if (place(node)) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (place(node) || tries > 30) clearInterval(iv);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
